<div class="account-pages">

    <div class="container-fluid px-4">

        <div class="row justify-content-center">

            <div class="col-12 d-flex justify-content-center">

                <div class="security-wrapper">

                    <!-- ===================================================== -->
                    <!-- PANEL IZQUIERDO -->
                    <!-- ===================================================== -->

                    <div class="security-left">

                        <div class="security-overlay"></div>

                        <div class="security-content">

                            <img
                                src="assets/images/volumetricos.png"
                                class="company-logo"
                                alt="Logo">

                            <span class="system-badge">

                                SISTEMA EMPRESARIAL

                            </span>

                            <h1>

                                Sistema de
                                <br>

                                Control
                                <br>

                                Volumétrico

                            </h1>

                            <p>

                                Plataforma diseñada para el control,
                                monitoreo y administración de información
                                volumétrica con altos estándares de
                                seguridad, disponibilidad y cumplimiento
                                regulatorio.

                            </p>

                            <div class="security-features">

                                <div class="feature">

                                    <div class="feature-icon">

                                        <i class="mdi mdi-shield-lock-outline"></i>

                                    </div>

                                    <div>

                                        <h6>

                                            Seguridad Avanzada

                                        </h6>

                                        <small>

                                            Protección mediante contraseñas
                                            seguras y cifrado.

                                        </small>

                                    </div>

                                </div>

                                <div class="feature">

                                    <div class="feature-icon">

                                        <i class="mdi mdi-chart-line"></i>

                                    </div>

                                    <div>

                                        <h6>

                                            Monitoreo

                                        </h6>

                                        <small>

                                            Información disponible en tiempo
                                            real para consulta.

                                        </small>

                                    </div>

                                </div>

                                <div class="feature">

                                    <div class="feature-icon">

                                        <i class="mdi mdi-cloud-check-outline"></i>

                                    </div>

                                    <div>

                                        <h6>

                                            Alta Disponibilidad

                                        </h6>

                                        <small>

                                            Plataforma empresarial siempre
                                            disponible.

                                        </small>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- ===================================================== -->
                    <!-- PANEL DERECHO -->
                    <!-- ===================================================== -->

                    <div class="security-right">

                        <div class="form-container">

                            <div class="text-center mb-5">

                                <div class="avatar-security">

                                    <i class="mdi mdi-lock-reset"></i>

                                </div>

                                <h2 class="mt-4">

                                    Cambio de contraseña

                                </h2>

                                <p>

                                    Actualiza tu contraseña para mantener
                                    protegida tu cuenta.

                                </p>

                            </div>

                            <form
                                [formGroup]="resetForm"
                                (ngSubmit)="onSubmit()">

                                <!-- =============================== -->
                                <!-- PASSWORD -->
                                <!-- =============================== -->

                                <div class="mb-4">

                                    <label class="form-label">

                                        Nueva contraseña

                                    </label>

                                    <div class="input-group input-group-lg">

                                        <span class="input-group-text">

                                            <i class="mdi mdi-lock-outline"></i>

                                        </span>

                                        <input

                                            [type]="showPassword ? 'text':'password'"

                                            class="form-control"

                                            formControlName="password"

                                            placeholder="Ingrese una contraseña segura"

                                            [ngClass]="{
                                                'is-invalid':
                                                submitted && f.password.errors
                                            }">

                                        <button

                                            class="btn btn-light"

                                            type="button"

                                            (click)="togglePassword()">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                showPassword
                                                ? 'mdi-eye-off'
                                                : 'mdi-eye'">

                                            </i>

                                        </button>

                                    </div>

                                    <!-- Barra -->

                                    <div class="progress mt-3">

                                        <div

                                            class="progress-bar"

                                            [style.width.%]="passwordStrength"

                                            [class.bg-danger]="passwordStrength<40"

                                            [class.bg-warning]="passwordStrength>=40 && passwordStrength<70"

                                            [class.bg-success]="passwordStrength>=70">

                                        </div>

                                    </div>

                                    <div class="strength-text">

                                        Fortaleza:

                                        <strong>

                                            {{strengthLabel}}

                                        </strong>

                                    </div>

                                    <!-- Reglas -->

                                    <div class="password-rules">

                                        <div [class.valid]="passwordRules.minLength">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                passwordRules.minLength
                                                ? 'mdi-check-circle'
                                                : 'mdi-circle-outline'">

                                            </i>

                                            Mínimo 8 caracteres

                                        </div>

                                        <div [class.valid]="passwordRules.upper">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                passwordRules.upper
                                                ? 'mdi-check-circle'
                                                : 'mdi-circle-outline'">

                                            </i>

                                            Una letra mayúscula

                                        </div>

                                        <div [class.valid]="passwordRules.lower">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                passwordRules.lower
                                                ? 'mdi-check-circle'
                                                : 'mdi-circle-outline'">

                                            </i>

                                            Una letra minúscula

                                        </div>

                                        <div [class.valid]="passwordRules.number">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                passwordRules.number
                                                ? 'mdi-check-circle'
                                                : 'mdi-circle-outline'">

                                            </i>

                                            Un número

                                        </div>

                                        <div [class.valid]="passwordRules.symbol">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                passwordRules.symbol
                                                ? 'mdi-check-circle'
                                                : 'mdi-circle-outline'">

                                            </i>

                                            Un carácter especial

                                        </div>

                                    </div>

                                    <div

                                        *ngIf="submitted && f.password.errors"

                                        class="invalid-feedback d-block mt-3">

                                        <div *ngIf="f.password.errors.required">

                                            La contraseña es obligatoria.

                                        </div>

                                        <div *ngIf="f.password.errors.pattern">

                                            La contraseña no cumple con los requisitos de seguridad.

                                        </div>

                                    </div>

                                </div>

                                <!-- =============================== -->
                                <!-- CONFIRMAR -->
                                <!-- =============================== -->

                                <div class="mb-4">

                                    <label class="form-label">

                                        Confirmar contraseña

                                    </label>

                                    <div class="input-group input-group-lg">

                                        <span class="input-group-text">

                                            <i class="mdi mdi-lock-check-outline"></i>

                                        </span>

                                        <input

                                            [type]="showPassword2 ? 'text':'password'"

                                            class="form-control"

                                            formControlName="password2"

                                            placeholder="Confirme la contraseña"

                                            [ngClass]="{
                                                'is-invalid':
                                                submitted && f.password2.errors
                                            }">

                                        <button

                                            class="btn btn-light"

                                            type="button"

                                            (click)="togglePassword2()">

                                            <i

                                                class="mdi"

                                                [ngClass]="
                                                showPassword2
                                                ? 'mdi-eye-off'
                                                : 'mdi-eye'">

                                            </i>

                                        </button>

                                    </div>

                                    <div

                                        *ngIf="submitted && f.password2.errors"

                                        class="invalid-feedback d-block">

                                        <div *ngIf="f.password2.errors.required">

                                            Debe confirmar la contraseña.

                                        </div>

                                        <div *ngIf="f.password2.errors.confirmedValidator">

                                            Las contraseñas no coinciden.

                                        </div>

                                    </div>

                                </div>

                                 <div class="d-flex justify-content-center align-items-center">
                                    <button type="submit" class="btn btn-info">
                                        Cambiar Password
                                    </button>
                                </div>

                                </form>